<template>
  <div>
    <div :data-booking="0" class="qq-quick-booking-container qui-quo-container">
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "QuickBookingQuiQuo",

  props: {
    tour: {
      type: Object,
      default: () => {}
    },
    selectedFlight: {
      type: Array,
      default: () => []
    },
    tourCardData: {
      type: Object,
      default: () => {}
    },
    residence: {
      type: Array,
      default: () => []
    },
    trevelerInfo: {
      type: Array,
      default: () => []
    },
    insuranceItems: {
      type: Array,
      default: () => []
    },
    transfer: {
      type: Array,
      default: () => []
    },
    additionalServices: {
      type: Array,
      default: () => []
    },
    flightSurcharge: {
      type: Array,
      default: () => []
    },
    busTransfer: {
      type: Array,
      default: () => []
    },
    railwayTransfer: {
      type: Array,
      default: () => []
    },
    excursion: {
      type: Array,
      default: () => []
    },
    visaItems: {
      type: Array,
      default: () => []
    },
    hotelServices: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {}
  },

  mounted() {},

  methods: {
    getAdultAndChildsFromHref() {
      let adult = null;
      let childs = null;
      let childAges = null;

      location.href.split('&').forEach(x => {
          if (x.includes('adultCount')) {
          adult = x.split('=')[1]
          }
          if (x.includes('childAges')) {
          childAges = x.split('=')[1]
          }
          if (x.includes('childAges')) {
          childs = x.split('=')[1].split(',').length
          }
      });

      return {
          adult,
          childs,
          childAges
      }
    },
    getPassengers() {
      const trevelerInfo = this.trevelerInfo;

      const titles = {
        firstname: "firstName",
        lastname: "lastName",
        patronymic: "secondName",
        birthdate: "birthday",
        birthplace: "address",
        passport: "serialNumber",
        passportdate: "issueDate",
        passportbywhom: "authority",
        passportdateend: "expire",
        passportrus: "serialNumberRus",
        passportdaterus: "issueDateRus",
        passportbywhomrus: "authorityRus",
        email: "email",
        phone: "phone"
      }

      const result = trevelerInfo.map(tourist => { 
        return tourist.flat().reduce((acc, subitem) => {
            const name = titles[subitem.code] 
            if (name) {
              acc[name] = subitem.value
            }
            return acc
        }, {})
      })

      const modifiedResult = result.map((el, index) => {
        let serial;
        let number;
        let documentType;
        let authority;
        let issueDate;
        let expireDate;

        if (el.serialNumberRus) {
          serial = el.serialNumberRus?.includes("/") ? el.serialNumberRus.split("/")[1] : "";
          number = el.serialNumberRus?.includes("/") ? el.serialNumberRus.split("/")[0] : "";
          documentType = "nationalPassport";
          authority = el.authorityRus;
          issueDate = el.issueDateRus;
          expireDate = "";
        } else if (!el.serialNumberRus && el.serialNumber) {
          serial = el.serialNumber?.includes("/") ? el.serialNumber.split("/")[1] : "";
          number = el.serialNumber?.includes("/") ? el.serialNumber.split("/")[0] : "";
          documentType = "internationalPassport";
          authority = el.authority;
          issueDate = el.issueDate;
          expireDate = el.expire;
        } else {
          serial = "";
          number = "";
          documentType = "";
          authority = "";
          issueDate = "";
          expireDate = "";
        }

        return {
          ...el,
          isClient: index === 0 ? true : false,
          docType: documentType,
          serial: serial,
          number: number,
          authority: authority,
          issueDate: issueDate,
          expire: expireDate,
          authorityCode: "", // не нашел этот параметр
        }
      })

      return modifiedResult
    },
    getHotels() {
      const tour = this.tour;
      const hotels = tour.Services.filter(x => x.SvKey === 3)
      const result = hotels.map(el => {
        return {
          hotelName: el.Hotel.Value,
          region: el.Resort.Value || "",
          country: el.Country.Value,
          dateStart: moment(el.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.EndDateTime).format('DD.MM.YYYY'),
          nights: hotels[0].DurationInNight, // это ночи, нужно будет уточнять, что подставляем, т.к. у нас 3 варианта длительности
          roomType: hotels[0].HotelDetails[0].Room.Value,
          boardType: hotels[0].HotelDetails[0].Pansion.Value,
          accomodation: hotels[0].HotelDetails[0].RoomCategory.Value
        }
      })

      return result 
    },
    getFlights() {
      const selectedFlight = this.selectedFlight

      const isGDS = selectedFlight.every(el => el.isGDS)
      let flightsWithDirection;
      
      if (isGDS) {
        flightsWithDirection = selectedFlight.map((x, idx) => ({
            ...x,
            direction: x.direction[idx]
        }))
      } else {
        flightsWithDirection = selectedFlight.reduce((accumulator, currentFlight) => {
          const { flights, isSecondDirection } = accumulator;

          // Обработка первого элемента
          if (flights.length === 0) {
            return {
              flights: [...flights, { ...currentFlight, direction: 1 }],
              isSecondDirection: false
            };
          }

          const lastFlight = flights[flights.length - 1];
          const currentDeparture = currentFlight.allData.DepartureCity.Key;
          const lastArrival = lastFlight.allData.ArrivalCity.Key;

          // Определение направления
          if (isSecondDirection) {
            return {
              flights: [...flights, { ...currentFlight, direction: 2 }],
              isSecondDirection: true
            };
          }

          // Проверка изменения направления
          const shouldSwitchDirection = currentDeparture === lastArrival;

          return {
            flights: [...flights, { 
              ...currentFlight, 
              direction: 1 
            }],
            isSecondDirection: shouldSwitchDirection
          };
        },
        { flights: [], isSecondDirection: false } // Начальное состояние
        ).flights;
      }

      const groupedFlights = flightsWithDirection.reduce((acc, flight) => {
        acc[flight.direction] ??= []
        acc[flight.direction].push(flight)
        return acc
      }, {})

      const segments = Object.values(groupedFlights).map(x => {
        return {
          segments: x.map(flight => ({
            airline: flight.airline,
            flightNumber: flight.allData.Flight.Value,
            serviceClass: `${flight.allData.FlightDetails[0].Tariff.Name} + (${flight.allData.FlightDetails[0].Tariff.Code})`,
            baggage: `${flight?.carryOnAndBaggage ? `${flight.carryOnAndBaggage[0]}, ${ flight.carryOnAndBaggage[1]}` : ""}`,
            departureDate: moment(flight.allData.BeginDateTime).format('DD.MM.YYYY'),
            departureTime: flight.timeFrom,
            departureCity: flight.allData.DepartureCity.Value,
            departureAirportID: flight.airportFrom,
            departureAirport: flight.allData.DepartureAirport.Value,
            departureTerminal: "",
            arrivalDate: moment(flight.allData.EndDateTime).format('DD.MM.YYYY'),
            arrivalTime: flight.timeTo,
            arrivalCity: flight.allData.ArrivalCity.Value,
            arrivalAirportID: flight.airportTo,
            arrivalAirport: flight.allData.ArrivalAirport.Value,
            travelTime: flight.fligthTime ? String(flight.fligthTime) : "",
            plane: flight.allData.Aircraft.Value
          }))
        }
      })

      const result = [
        {
          sectors: segments
        }
      ]

      return result
    },
    getTransfers(passengers) {
      const transfers = this.transfer[0]
      const adult = parseInt(passengers.adult) || 0
      const childs = parseInt(passengers.childs) || 0

      let result = transfers.map(el => {
        if (!el.isChecked) return
        return {
          description: el.code + ", " + el.transferSelected.label,
          totalPrice: el.transferSelected.allData.Cost,
          totalPriceCurrency: el.transferSelected.rate,
          dateStart: moment(el.allData.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.allData.EndDateTime).format('DD.MM.YYYY'),
          count: adult + childs,
          passengers: {
            adults: adult, 
            children: childs,
            infants: null
          }
        }
      })

      result = result.filter(x => x)
      return result
    },
    getInsurances() {
      const insurances = this.insuranceItems.map(el => {
        return {
          description: el.title || el.lable,
          totalPrice: el.cost,
          totalPriceCurrency: el.tourRate,
          dateStart: moment(el.serviceAllData.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.serviceAllData.EndDateTime).format('DD.MM.YYYY'),
          count: 1,
        }
      })

      return insurances
    },
    getSupplements(passengers) {
      const adult = parseInt(passengers.adult) || 0
      const childs = parseInt(passengers.childs) || 0
      const tour = this.tour;

      const additionalServices = this.additionalServices.filter(x => x.items[0].itemSelected.isChecked).map(el => {
        return {
          description: el.items[0].itemSelected.allData.ServiceName + "::" + el.items[0].itemSelected.label,
          totalPrice: el.items[0].itemSelected.allData.Details[0].Cost,
          totalPriceCurrency: tour.Rate,
          dateStart: moment(el.items[0].itemSelected.allData.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.items[0].itemSelected.allData.EndDateTime).format('DD.MM.YYYY'),
          count: adult + childs,
          passengers: {
            adults: adult, 
            children: childs,
            infants: null
          }
        }
      })

      const flightSurcharge = this.flightSurcharge.filter(x => x.isChecked).map(el => {
        return {
          description: el.ServiceName + "::" + el.Code.Value,
          totalPrice: el.Details[0].Cost,
          totalPriceCurrency: tour.Rate,
          dateStart: moment(el.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.EndDateTime).format('DD.MM.YYYY'),
          count: adult + childs,
          passengers: {
            adults: adult, 
            children: childs,
            infants: null
          }
        }
      })

      const busTransfer = this.busTransfer.map(el => {
        return {
          description: "BUS" + "::" + el.busTransfer,
          totalPrice: el.totalCost,
          totalPriceCurrency: el.parent.Rate,
          dateStart: moment(el.allData.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.allData.EndDateTime).format('DD.MM.YYYY'),
          count: adult + childs,
          passengers: {
            adults: adult, 
            children: childs,
            infants: null
          }
        }
      })

      const railwayTransfer = this.railwayTransfer.map(el => {
        return {
          description: "TRAIN" + "::" + el.railwayTransfer,
          totalPrice: el.totalCost,
          totalPriceCurrency: el.parent.Rate,
          dateStart: moment(el.allData.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.allData.EndDateTime).format('DD.MM.YYYY'),
          count: adult + childs,
          passengers: {
            adults: adult, 
            children: childs,
            infants: null
          }
        }
      })

      const excursion = this.excursion.filter(x => x.isChecked).map(el => {
        return {
          description: el.selectedItem2.ServiceName + "::" + el.selectedItem2.Code.Value,
          totalPrice: el.excursionSelected.value,
          totalPriceCurrency: el.excursionSelected.rate,
          dateStart: moment(el?.selectedItem2.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el?.selectedItem2.EndDateTime).format('DD.MM.YYYY'),
          count: adult + childs,
          passengers: {
            adults: adult, 
            children: childs,
            infants: null
          }
        }
      })

      const visaItems = this.visaItems.map(el => {
        return {
          description: el.serviceAllData.ServiceName + "::" + (el.title || el.lable),
          totalPrice: el.cost,
          totalPriceCurrency: el.tourRate,
          dateStart: moment(el.serviceAllData.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.serviceAllData.EndDateTime).format('DD.MM.YYYY'),
          count: 1,
        }
      })

      const hotelServices = this.hotelServices.flat().map(el => {
        return {
          description: el.ServiceName + "::" + el.Code.Value,
          totalPrice: el.Details[0].Cost,
          totalPriceCurrency: tour.Rate,
          dateStart: moment(el.BeginDateTime).format('DD.MM.YYYY'),
          dateEnd: moment(el.EndDateTime).format('DD.MM.YYYY'),
          count: 1,
        }
      })

      const allServices = [...additionalServices, ...flightSurcharge, ...busTransfer, ...railwayTransfer, ...excursion, ...visaItems, ...hotelServices]

      return allServices
    }
  },
  computed: {
    getSettings() {
      return this.$store.getters['getSettings'];
    },
    getQuiQuoBookingJSON() {
      const tour = this.tour;
      const tourCardData = this.tourCardData;
      const { adult, childs } = this.getAdultAndChildsFromHref()

      const quiQuoBookingObject = {
        booking: {
          general: {
            adults: parseInt(adult),
            children: childs || 0,
            prices: {
              inForeignCurrency: {
                currency: tourCardData.tourCurrency.IsoCode,
                gross: parseFloat(tourCardData.totalPrice),
                nett: parseFloat(tourCardData.price),
                paymentSchedule: [], // не нашел этот параметр
                payments: [] // не нашел этот параметр
              },
              inNationalCurrency: {
                currency: tourCardData.nationalCurrency.IsoCode,
                gross: parseFloat(tourCardData.nationalTotalPrice) || 0,
                nett:  parseFloat(tourCardData.nationalPrice) || 0,
                paymentSchedule: [], // не нашел этот параметр
                payments: [] // не нашел этот параметр
              },
              paidStatus: "Unknown" // не нашел этот параметр
            },
            dateStart: tourCardData.beginDate ?  moment(tourCardData.beginDate).format('DD.MM.YYYY') : "",
            dateEnd: tourCardData.endDate ? moment(tourCardData.endDate).format('DD.MM.YYYY') : "",
            nights: tour.Duration, // это дни тура, нужно будет уточнять, что подставляем, т.к. у нас 3 варианта длительности
            tourOperatorReference: '', // не нашел этот параметр
            cityFrom: tour.CityDepature.Value,
            operator: this.getSettings.FullNameCompany,
          },
          passengers: this.getPassengers(),
          hotels: this.getHotels(),
          client: this.getPassengers()[0],
          flights: this.getFlights(),
          insurance: this.getInsurances(),
          supplements: this.getSupplements({ adult, childs }),
          transfers: this.getTransfers({ adult, childs }),
        }
      }

      return JSON.stringify(quiQuoBookingObject)
    }
  },

  watch: {
    getQuiQuoBookingJSON: {
      deep: true,
      handler(val) {
        sessionStorage.setItem("qq_qb_0", val);
      }
    }
  },

  components: {
  },
};
</script>

<style>
  .qui-quo-container {
      display: flex;
      justify-content: center;
  }
</style>
